module.exports = __webpack_public_path__ + "img/custom-download.c5eef2b3.svg";